export default {
      id: "data-export-white-usage",
      viewBox: "0 0 25 25",
      url: "images/" + "sprite.svg#data-export-white-usage",
      toString: function () {
        return this.url;
      }
    }